/*
 * **********************************************************************
 *  Copyright (c) 2023-2023 HC BUSINESS ltd All rights reserved.
 * @Update Date     : 2023/11/14 上午11:03
 * @Author           : JiaYi.Luo
 * @Email            : jarvis.luo.chen@gmail.com
 * **********************************************************************
 */

import { ResponseStructure } from '@/typings/request';
import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { Toast } from 'antd-mobile';

/**
 * @name errorConfig 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
  // 请求拦截器
  requestInterceptors: [
    (config: RequestOptions) => {
      // 拦截请求配置，进行个性化处理。

      // 添加请求统一前缀
      const prefix = API_URL;
      let { url } = config;
      if (url && !url.startsWith(prefix)) {
        url = `${prefix}/${url}`;
      }

      return { ...config, url };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data } = response as unknown as ResponseStructure;

      if (data?.code !== 1) {
        const message = (data.msg as string) || '请求失败！';
        Toast.show(message);
        if (data.data['reLogin'] === 1 || data.data['re-login'] === 1) {
          window.location.href = data.url;
        }
      }
      return response;
    },
  ],
};
